// Angular
import { Component, OnInit, ChangeDetectionStrategy, OnDestroy, ChangeDetectorRef, Inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
// Material
import { MatPaginator, MatSort, MatDialog, MatTableDataSource, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
// RxJS
import { Observable, BehaviorSubject, Subscription } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
// NGRX
// Service
import { SubheaderService } from 'app/core/_base/layout';
import { LayoutUtilsService,  MessageType } from 'app/core/_base/crud';
import { PhongHopService } from '../phong-hop-service/phong-hop.service';
//Models

import { PhongHopModel } from '../phong-hop-model/phong-hop.model';


@Component({
	selector: 'kt-phong-hop-edit',
	templateUrl: './phong-hop-edit.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
		
export class PhongHopEditComponent implements OnInit, OnDestroy {
	// Public properties
	PhongHop: PhongHopModel;
	PhongHopForm: FormGroup;
	hasFormErrors: boolean = false;
	loadingSubject = new BehaviorSubject<boolean>(true);
	loading$: Observable<boolean>;
	viewLoading: boolean = false;
	isChange: boolean = false;
	fixedPoint = 0;
	disBtnSubmit:boolean=false;
	isZoomSize: boolean = false;
	private componentSubscriptions: Subscription;
	constructor(
		public dialogRef: MatDialogRef<PhongHopEditComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private PhongHopFB: FormBuilder,
		public dialog: MatDialog,
		private layoutUtilsService: LayoutUtilsService,
		private changeDetectorRefs: ChangeDetectorRef,
		private phonghopsService: PhongHopService) {}

	/**
	 * On init
	 */
	ngOnInit() {
		this.viewLoading = false;
		this.PhongHop=new PhongHopModel();
		if(this.data.PhongHop&&Number(this.data.PhongHop.Id_Phong)>0){
			this.phonghopsService.getPhongHopById(this.data.PhongHop.Id_Phong).subscribe(res => {
				if(res.status==1&&res.data){				
					this.PhongHop=res.data;		
					this.createForm();
					this.changeDetectorRefs.detectChanges();		
				}
			});
		}	
		else{
			this.PhongHop= this.data.PhongHop;
		}	
		this.createForm();	
	}

	/**
	 * On destroy
	 */
	ngOnDestroy() {
		if (this.componentSubscriptions) {
			this.componentSubscriptions.unsubscribe();
		}
	}
	
	/**
	 * Create form
	 */
	createForm() {
		this.PhongHopForm = this.PhongHopFB.group({		
				tenPhong: [(this.PhongHop.TenPhong == null  || this.PhongHop.TenPhong == '') ?  ''	: this.PhongHop.TenPhong, Validators.required],
				moTa: [(this.PhongHop.MoTa == null  || this.PhongHop.MoTa == '') ?  ''	: this.PhongHop.MoTa],
				viTri:[this.PhongHop.ViTri]
		});
	}
	/**
	 * Returns page title
	 */
	getTitle(): string {
			if (this.PhongHop.Id_Phong == 0) {
				return 'Thêm mới phòng họp';
			}
        return `Chỉnh sửa phòng họp - ${this.PhongHop.TenPhong} `;
	}

	/**
	 * Check control is invalid
	 * @param controlName: string
	 */
	isControlInvalid(controlName: string): boolean {
		const control = this.PhongHopForm.controls[controlName];
		const result = control.invalid && control.touched;
		return result;
	}

	/**
	 * Save data
	 *
	 * @param withBack: boolean
	 */
	onSubmit(type: boolean) {
		this.hasFormErrors = false;
		const controls = this.PhongHopForm.controls;
		/** check form */
		if (this.PhongHopForm.invalid) {
			Object.keys(controls).forEach(controlName =>
				controls[controlName].markAsTouched()
			);

			this.hasFormErrors = true;
			return;
		}
		this.disBtnSubmit=true;
		// tslint:disable-next-line:prefer-const
		let editedPhongHop = this.preparePhongHops();
		
			if (this.PhongHop.Id_Phong > 0) {
				this.updatePhongHop(editedPhongHop)
				return;
			}
		
		this.addPhongHop(editedPhongHop,type);
	}

	/**
	 * Returns object for saving
	 */
	preparePhongHops(): PhongHopModel {
		const controls = this.PhongHopForm.controls;
		const _PhongHop = new PhongHopModel();    
		_PhongHop.clear();
			_PhongHop.TenPhong = controls['tenPhong'].value;
			_PhongHop.MoTa = controls['moTa'].value?controls['moTa'].value:"";
			_PhongHop.ViTri = controls['viTri'].value?controls['viTri'].value:1;
		//gán lại giá trị id 		
			if (this.PhongHop.Id_Phong > 0) {
				_PhongHop.Id_Phong = this.PhongHop.Id_Phong;
			}
		
		return _PhongHop;
	}
	/**
	 * Add item
	 *
	 * @param _PhongHop: PhongHopModel
	 * @param withBack: boolean
	 */
	addPhongHop(_PhongHop: PhongHopModel, withBack: boolean = false) {		
		this.phonghopsService.createPhongHop(_PhongHop).subscribe(res => {
			
			this.disBtnSubmit=false;
			if (res&&res.status == 1) {				
				this.isChange = true;				
				const message = `Thêm thành công`;
				this.layoutUtilsService.showActionNotification(message, MessageType.Create, 5000, true, false);
				this.PhongHopForm.reset();
				if(withBack)
					this.dialogRef.close(this.isChange);
			}
			else {
				this.layoutUtilsService.showActionNotification(res.error.message, MessageType.Create, 0, true, false);
			}	
			this.changeDetectorRefs.detectChanges();				
		});
	}

	/**
	 * Update item
	 *
	 * @param _PhongHop: PhongHopsModel
	 * @param withBack: boolean
	 */
	updatePhongHop(_PhongHop: PhongHopModel, withBack: boolean = false) {
		
		this.phonghopsService.updatePhongHop(_PhongHop).subscribe(res => {
			this.disBtnSubmit=false;
			if (res.status == 1) {
				this.isChange = true;
				const message = `Cập nhật thành công`;
				this.layoutUtilsService.showActionNotification(message, MessageType.Update, 5000, true, false);
				this.dialogRef.close(this.isChange);
			}
			else {
				this.layoutUtilsService.showActionNotification(res.error.message, MessageType.Update, 0, true, false);
			}			
		});
	}
	
	/**
	 * Close alert
	 *
	 * @param $event
	 */
	onAlertClose($event) {
		this.hasFormErrors = false;
	}

	numberOnly(event): boolean {
		const charCode = (event.which) ? event.which : event.keyCode;
		if (charCode > 31 && (charCode < 48 || charCode > 57)) {
			return false;
		}
		return true;
	}

	closeDialog(){
		this.dialogRef.close(this.isChange);
	}
	ValidateChangeNumberEvent(event: any) {
		
		if(event.target.value == null || event.target.value == ''){
			const message = 'Không thể để trống dữ liệu';
			this.layoutUtilsService.showActionNotification(message, MessageType.Create, 0, true, false);
			return false;
		}
		var count = 0;
		for(let i = 0; i < event.target.value.length; i++){
			if(event.target.value[i] == '.'){
				count += 1;
			}
		}
		var regex = /[a-zA-Z -!$%^&*()_+|~=`{}[:;<>?@#\]]/g;
		var found = event.target.value.match(regex);
		if (found != null) {
			const message = 'Dữ liệu không gồm chữ hoặc kí tự đặc biệt';
			this.layoutUtilsService.showActionNotification(message, MessageType.Create, 0, true, false);
			return false;;
		}
		if (count >= 2) {
			const message = 'Dữ liệu không thể có nhiều hơn 2 dấu .';
			this.layoutUtilsService.showActionNotification(message, MessageType.Create, 0, true, false);
			return false;;
		}
		return true;
	}

	formatNumber(item: string){
		if(item == '' || item == null || item == undefined)	return '';
		return Number(Math.round(parseFloat(item + 'e' + this.fixedPoint)) + 'e-'+ this.fixedPoint).toFixed(this.fixedPoint)
	}

	f_currency(value: string): any {
		if (value == null || value == undefined || value == '') value = '0.00';
		let nbr = Number((value.substring(0,value.length - (this.fixedPoint + 1)) + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + value.substr(value.length - (this.fixedPoint + 1),(this.fixedPoint + 1));
	}

	f_currency_V2(value: string): any {
		if(value == '-1') return '';
		if (value == null || value == undefined || value == '') value = '0';
		let nbr = Number((value + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
	}

	changeValueOfForm(controlName: string, event: any){
		if(this.ValidateChangeNumberEvent(event)){
			let tmpValue = this.PhongHopForm.controls[controlName].value.replace(/,/g, "");
			this.PhongHopForm.controls[controlName].setValue(
				
					this.f_currency_V2(tmpValue)
				
			);
		}
		else{
			this.PhongHopForm.controls[controlName].setValue(event.target.value);
		}
	}


	f_convertDateTime(date: string){
		var componentsDateTime = date.split("/");
		var date = componentsDateTime[0];
		var month = componentsDateTime[1];
		var year = componentsDateTime[2];
		var formatConvert = year + "-" + month + "-" + date + "T00:00:00.0000000";
		return new Date(formatConvert);
	}
	f_convertDate(p_Val: any) {
		let a = p_Val === "" ? new Date() : new Date(p_Val);
		return a.getFullYear() + "/" + ("0" + (a.getMonth() + 1)).slice(-2) + "/" + ("0" + (a.getDate())).slice(-2);
	}

	resizeDialog(){
		if(!this.isZoomSize){
			this.dialogRef.updateSize('100vw', '100vh');
			this.isZoomSize = true;
		}
		else if(this.isZoomSize){
			this.dialogRef.updateSize('900px', 'auto');
			this.isZoomSize = false;
		}
		
	}
}
